import { IconProject, IconCursor, IconTime, IconTag, IconBrand } from 'assets'
import { ViewerTabTableColumn, TableCell } from 'components/viewers/ViewerTabTable/types'

export enum TotalInteractionColEnums {
  BRAND = 'Brand',
  PROJECT = 'Project',
  INTERACT = 'Interact',
  ADDED_AT = 'Added At',
  TAGS = 'Tag'
}

type TotalInteractionColumnsType = {
  [key in TotalInteractionColEnums]:
  ViewerTabTableColumn<TotalInteractionColEnums>
}
export const totalInteractionColumns: TotalInteractionColumnsType = {
  [TotalInteractionColEnums.BRAND]: {
    label: TotalInteractionColEnums.BRAND,
    icon: IconBrand,
    sortable: false,
    width: '25%'
  },
  [TotalInteractionColEnums.PROJECT]: {
    icon: IconProject,
    label: TotalInteractionColEnums.PROJECT,
    sortable: false,
    width: '25%'
  },
  [TotalInteractionColEnums.INTERACT]: {
    icon: IconCursor,
    label: TotalInteractionColEnums.INTERACT,
    sortable: true,
    width: '10%'
  },
  [TotalInteractionColEnums.ADDED_AT]: {
    icon: IconTime,
    label: TotalInteractionColEnums.ADDED_AT,
    sortable: false,
    width: '10%'
  },
  [TotalInteractionColEnums.TAGS]: {
    icon: IconTag,
    label: TotalInteractionColEnums.TAGS,
    sortable: false,
    width: '30%'
  }
}

export type TotalInteractionLineInfo = {
  [key in TotalInteractionColEnums]: TableCell
} & {
  children?: TotalInteractionLineInfo[]
}
